import Sugar from 'sugar'

Sugar.extend({
    namespaces: [Array, Object, Number, Date, Range, String, RegExp],
})

Sugar.extend({ namespaces: [Function], except: ['once'] })
